import { render, staticRenderFns } from "./CircleActionMenu.vue?vue&type=template&id=04867a9a&scoped=true&"
import script from "./CircleActionMenu.vue?vue&type=script&lang=js&"
export * from "./CircleActionMenu.vue?vue&type=script&lang=js&"
import style0 from "./CircleActionMenu.vue?vue&type=style&index=0&id=04867a9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04867a9a",
  null
  
)

export default component.exports